import { List } from '../objects/list';
import { Error } from '../objects/error';
import { ModelPrice } from '../objects/modelPrice';
import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../objects/column';
export const ADD_PREFERENCES = 'PRICE_MODEL_ADD_PREFERENCES';
export const MOVE_DOWN_COLUMN = 'PRICE_MODEL_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'PRICE_MODEL_MOVE_UP_COLUMN';
export const RESET_ADD_MODEL = 'PRICE_MODEL_RESET_ADD_MODEL';
export const RESET_FILTERS = 'PRICE_MODEL_RESET_FILTERS';
export const SET_ERRORS = 'PRICE_MODEL_SET_ERRORS';
export const SET_EXPORT_TYPE = 'PRICE_MODEL_SET_EXPORT_TYPE';
export const SET_LIMIT = 'PRICE_MODEL_SET_LIMIT';
export const SET_LIST = 'PRICE_MODEL_SET_LIST';
export const SET_ORDER_BY = 'PRICE_MODEL_SET_ORDER_BY';
export const SET_PAGE = 'PRICE_MODEL_SET_PAGE';
export const SET_PREFERENCES = 'PRICE_MODEL_SET_PREFERENCES';
export const SET_PRICE_MODEL = 'PRICE_MODEL_SET_PRICE_MODEL';
export const SET_RUNNING = 'PRICE_MODEL_SET_RUNNING';
export const SET_SEARCH = 'PRICE_MODEL_SET_SEARCH';
export const SET_STEP = 'PRICE_MODEL_SET_STEP';
export const TOGGLE_CANCEL_MODAL = 'PRICE_MODEL_TOGGLE_CANCEL_MODAL';
export const TOGGLE_COLUMN = 'PRICE_MODEL_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'PRICE_MODEL_TOGGLE_CREATE';
export const TOGGLE_EXPORT = 'PRICE_MODEL_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'PRICE_MODEL_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'PRICE_MODEL_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'PRICE_MODEL_TOGGLE_REFRESH';
export const UPDATE_LIST_ITEM_VISIBILITY = 'PRICE_MODEL_UPDATE_LIST_ITEM_VISIBILITY';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'PRICE_MODEL_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'PRICE_MODEL_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'PRICE_MODEL_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'PRICE_MODEL_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'PRICE_MODEL_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_LAST_AUTHOR = 'PRICE_MODEL_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_PERIOD = 'PRICE_MODEL_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'PRICE_MODEL_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_FILTER_STATUS = 'UPDATE_FILTER_STATUS';
export const UPDATE_MODEL = 'PRICE_MODEL_UPDATE_MODEL';
export const UPDATE_NAME = 'PRICE_MODEL_UPDATE_NAME';
export const UPDATE_NAME_LOCALE = 'PRICE_MODEL_UPDATE_NAME_LOCALE';
export const SET_COLUMNS = 'PRICE_MODEL_SET_COLUMNS';
export const RESIZE_COLUMN = 'PRICE_MODEL_RESIZE_COLUMN';


interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}

interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}
interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetAddModelAction {
    type: typeof RESET_ADD_MODEL
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface SetStepAction {
    type: typeof SET_STEP,
    payload: string | null
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetPriceModelAction {
    type: typeof SET_PRICE_MODEL,
    payload: ModelPrice | null
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateFilterStatusTypeAction {
    type: typeof UPDATE_FILTER_STATUS,
    payload: string
}

interface UpdateListItemVisibilityAction {
    type: typeof UPDATE_LIST_ITEM_VISIBILITY,
    payload: ModelPrice
}

interface UpdateModelAction {
    type: typeof UPDATE_MODEL,
    payload: string[]
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

interface UpdateNameLocalAction {
    type: typeof UPDATE_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

export type PriceModelActionTypes =
    SetColumnsAction |
    ResizeColumnAction |
    AddPreferencesAction |
    MoveDownColumnAction|
    MoveUpColumnAction|
    ResetAddModelAction |
    ResetFiltersAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPreferencesAction |
    SetPriceModelAction |
    SetRunningAction |
    SetSearchAction |
    SetStepAction |
    ToggleCancelModalAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleNewAction |
    ToggleRefreshAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateFilterStatusTypeAction |
    UpdateListItemVisibilityAction |
    UpdateModelAction|
    UpdateNameAction |
    UpdateNameLocalAction